import { render, staticRenderFns } from "./ReceiverDeliveryForm.vue?vue&type=template&id=64ed3374&"
import script from "./ReceiverDeliveryForm.vue?vue&type=script&lang=ts&"
export * from "./ReceiverDeliveryForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports